import React, { useRef, useEffect } from "react";
import dynamic from 'next/dynamic';
import Head from 'next/head'
import Image from 'next/image'
import { Inter } from 'next/font/google'
import styles from '../../styles/Home.module.css'

import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import Layout from "../../../components/layout";

const FaceMeshComponent = dynamic(() => import('../../../components/facemesh'), {
    ssr: false
  });
  

const HomePage = () => {
return (
  <>
    <Head>
      <title>AI Skintone Analyzer | StyleSense.io</title>
      <meta
        name="description"
        content="Simply take a selfie to identify your skintone and undertone. Then, use our shade match guides to select the best foundation or concealer shades for your skin type. Developed by a woman of color for people of all skin tones and types."
        key="desc"
      />
    </Head>       
    {/* <main className="min-h-screen flex flex-col justify-between">
    <Navbar />
    <FaceMeshComponent page={"skintone_analyzer"}/>     
    <Footer />
    </main> */}
    <Layout page={"skintone_analyzer"} selectedOption={"skintone_analyzer"}/>
  </>
    )
}

export default HomePage;